import { render, staticRenderFns } from "./useTable.vue?vue&type=template&id=137ade75&"
import script from "./useTable.vue?vue&type=script&lang=js&"
export * from "./useTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports